<template>
  <div id="app">
<form  @submit="onSubmit" >

    <ion-item>
      <ion-label position="stacked">Titel <ion-text color="danger">*</ion-text></ion-label>
      <ion-input required :value="box.title" @ionInput="box.title = $event.target.value"></ion-input>
    </ion-item>

  <ion-item>
    <ion-label>Typ</ion-label>
    <ion-select ok-text="Ok" cancel-text="Abbrechen"  :value="box.type" @ionChange="box.type = $event.target.value">
      <ion-select-option value="tab">Tab</ion-select-option>
      <ion-select-option value="box">Box</ion-select-option>
    </ion-select>
  </ion-item>

  <ion-item v-if="box.type === 'tab'">
    <ion-label>Tab Container</ion-label>
    <ion-select ok-text="Ok" cancel-text="Abbrechen"  :value="box.parent" @ionChange="box.parent = $event.target.value">
      <ion-select-option v-for="parent in parents" :key="parent.id" :value="parent.id">{{ parent.title }}</ion-select-option>
    </ion-select>
  </ion-item>

  <ion-item>
    <ion-label>Farbe</ion-label>
    <ion-select ok-text="Ok" cancel-text="Abbrechen"  :value="box.color" @ionChange="box.color = $event.target.value">
      <ion-select-option v-for="color in colors" :key="color.value" :value="color.value">{{ color.label }}</ion-select-option>
    </ion-select>
  </ion-item>

  <ion-item>
    <ion-label>Dashboard</ion-label>
    <ion-select ok-text="Ok" cancel-text="Abbrechen"  :value="box.dashboard" @ionChange="box.dashboard = $event.target.value">
      <ion-select-option v-for="dashboard in dashboards" :key="dashboard.value" :value="dashboard.value">{{ dashboard.label }}</ion-select-option>
    </ion-select>
  </ion-item>

    <ion-item>
      <ion-label>Verstecken</ion-label>
      <ion-toggle :checked="box.hidden === true"  @ionChange="box.hidden = $event.target.value"/>
    </ion-item>


      <a href="/#/box/list/" class="link-button">Abbrechen</a>
      <ion-button type="submit">Speichern</ion-button>

</form>
  </div>
</template>

<script>

  import {mapActions, mapGetters} from "vuex";


  export default {
    name: "BoxFields",
    props: ['modus', 'id'],
    data(){
      return {
        //parents: [],
        box:  {
              type: 'tab',
              title: '',
              parent: 0,
              selected: false,
              color: 'default',
              hidden: false,
              active: false,
              dashboard: 'business'
            },
        colors: [
          {
            label: 'default',
            value: 'default'
          },
          {
            label: 'gelb',
            value: 'yellow'
          },
          {
            label: 'grün',
            value: 'green'
          },
          {
            label: 'blau',
            value: 'blue'
          },
        ],
        dashboards: [
          {
            label: 'privat',
            value: 'private'
          },
          {
            label: 'geschäftlich',
            value: 'business'
          },
        ],
      }
    },

    methods: {
      ...mapActions(["addBox", "getBox", "updateBox", "getBoxes"]),
      onSubmit(e){
        e.preventDefault();
        if(this.modus === 'new') {
          this.addBox(this.box);
        } else {
          this.updateBox(this.box);
        }
        this.$router.push('/box/');
      },
    },
    components: {

    },
    computed: {
      ...mapGetters(['editBox', 'allBoxes']),
      parents(){
        return  this.allBoxes.filter(function(box) {
       //   console.log(box.type + ' ' + box.parent);
          return box.type == 'tab' && box.parent == 0
        });
      }

    },
    async created() {
      if(this.id) {
        await this.getBox(this.id);
        this.box = this.editBox;
      }
      await this.getBoxes();

    }
  };
</script>

<style scoped>

  ion-input,
  ion-item {
    --background: #3E4143;
    --color: #B6B6B6;
    --icon-color: #B6B6B6;
  }

  .link-button {
    text-transform: uppercase;
    margin-top: 40px;
    display: inline-block;
  }

  ion-button {
    float: right;
    margin-top: 40px;
  }



</style>
